var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9079 4.04548C8.80143 3.9058 8.65065 3.80949 8.48309 3.77009L8.31171 3.74958H4.25116C3.96493 3.74958 3.7033 3.91299 3.57733 4.16999C3.45158 4.42708 3.48386 4.73346 3.65936 4.95954L9.78534 12.8492L4.24384 18.9766L3.56134 19.7278C3.38623 19.9205 3.52297 20.2295 3.78338 20.2295H4.80048C5.00459 20.2292 5.20785 20.1461 5.35565 19.983L10.7199 14.0518L15.2917 19.939C15.4337 20.1219 15.652 20.229 15.8835 20.2291H19.7243C20.0091 20.229 20.27 20.0681 20.3967 19.8131C20.523 19.5577 20.4945 19.2516 20.322 19.025L13.8752 10.564L18.9099 5.00349L19.5961 4.25442C19.7724 4.06198 19.6359 3.75177 19.3749 3.75177H18.411H18.2943C18.1099 3.76604 17.9304 3.848 17.7966 3.99568L12.9509 9.35114L8.9079 4.04548ZM18.2097 18.7291H16.2512L5.78192 5.24958H7.9411L18.2097 18.7291Z",
    fill: "#FC4C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.bfb2f83fbf2aab80bb5c74ac4d4ab390.svg";
export { ForwardRef as ReactComponent };